
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#767679","viewBox":"0 0 30 30","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.12 6.946c-2.424-1.948-6.257-2.278-6.419-2.292a.61.61 0 00-.604.357c-.004.008-.218.629-.425 1.228 2.817.493 4.731 1.587 4.833 1.647A1 1 0 0122 9.75a.99.99 0 01-.501-.135C21.471 9.598 18.663 8 15.002 8S8.531 9.599 8.503 9.615a1 1 0 11-1.006-1.729c.102-.06 2.023-1.158 4.848-1.65l-.442-1.225a.6.6 0 00-.604-.357c-.162.013-3.995.343-6.451 2.318C3.564 8.158 1 15.092 1 21.087a.6.6 0 00.08.301c1.771 3.11 6.599 3.924 7.699 3.959a.617.617 0 00.511-.249l1.19-1.612c-2.61-.629-3.99-1.618-4.073-1.679a1 1 0 011.181-1.614C7.625 20.217 10.172 22 15 22c4.847 0 7.387-1.79 7.412-1.808a1 1 0 111.183 1.613c-.083.061-1.456 1.048-4.06 1.677l1.175 1.615a.61.61 0 00.492.25c1.12-.036 5.948-.85 7.718-3.96a.6.6 0 00.08-.301c0-5.994-2.564-12.928-3.88-14.14zM11 19c-1.105 0-2-1.119-2-2.5s.895-2.5 2-2.5 2 1.119 2 2.5-.895 2.5-2 2.5zm8 0c-1.105 0-2-1.119-2-2.5s.895-2.5 2-2.5 2 1.119 2 2.5-.895 2.5-2 2.5z"}})])
          )
        }
      }
    